module.exports = __webpack_public_path__ + "img/L4A.e1ad9b21.jpg";